<template>
  <section id="settings">
    <contact-details />
    <update-password v-if="myProfile.hasPassword" />
    <close-account />
  </section>
</template>

<script>
import { mapGetters } from "vuex";
import CloseAccount from "../components/user-settings/CloseAccount";
import ContactDetails from "../components/user-settings/ContactDetails";
import UpdatePassword from "../components/user-settings/UpdatePassword";

export default {
  name: "UserSettings",
  components: {
    CloseAccount,
    ContactDetails,
    UpdatePassword,
  },
  computed: {
    ...mapGetters(["myProfile"]),
  },
};
</script>
